import styled from "@emotion/styled";

export const CheckboxContainer = styled.div`
  .ps-contract {
    padding: 0 !important;
  }
`;
